import { render, staticRenderFns } from "./GiftSection.vue?vue&type=template&id=4d399f1f&scoped=true"
import script from "./GiftSection.vue?vue&type=script&lang=js"
export * from "./GiftSection.vue?vue&type=script&lang=js"
import style0 from "./GiftSection.vue?vue&type=style&index=0&id=4d399f1f&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d399f1f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/centurygame/web-vip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d399f1f')) {
      api.createRecord('4d399f1f', component.options)
    } else {
      api.reload('4d399f1f', component.options)
    }
    module.hot.accept("./GiftSection.vue?vue&type=template&id=4d399f1f&scoped=true", function () {
      api.rerender('4d399f1f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/features/gift/GiftSection.vue"
export default component.exports